import { z } from 'zod';
import api from '~/utils/api';
import { MiddlewareFunction } from '~/utils/routing';

// enable the order to be available to the app shell via the app context
export const middleware: MiddlewareFunction = async ({ params }, ctx) => {
  // TODO figure out the types for the middleware because app gets defined in a higher scope
  if (!ctx.app) {
    return ctx;
  }

  const { idFromPlatform, store } = z
    .object({
      idFromPlatform: z.string(),
      store: z.string(),
    })
    .parse(params);

  const state = ctx.app.getState();

  if (!state.settings) {
    return ctx;
  }

  const validOrder =
    !!state.order &&
    state.order.idFromPlatform === idFromPlatform &&
    store === state.order.storeSlug;

  if (!validOrder) {
    const order = await api.fetchCrewOrder({
      params: { storefrontId: state.settings.storefrontId },
      query: { idFromPlatform },
    });

    ctx.app.dispatch(ctx.app.actions.setOrder(order));
  }

  return ctx;
};
